import React from 'react'
import { Link } from 'gatsby'
import { Layout, Showcase, Header, SectionTitle } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        inProgress="true"
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Input Chip"
          text={
            <p>
              Input chips represent user-entered or selected information. They
              appear inline within a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/text-input/design'}
              >
                text input
              </Link>
              . Input chips use the primary green treatment and do not change
              appearance. They are always dismissible.
            </p>
          }
          code={code.chipBase}
        >
          <div class="c-chip__container">
            <div class="c-chip c-chip--active">
              Lorem Ipsum
              <div class="c-chip__close">
                <i class="icon icon--x" />
              </div>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Choice Chip"
          text={
            <p>
              Choice chips allow the user to select one option out of a group of
              many, similar to{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/radio/design'}
              >
                radios
              </Link>{' '}
              or{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/button-group/design'}
              >
                button groups
              </Link>{' '}
              . Like all inputs, choice chips should always appear with a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/label/design'}
              >
                label
              </Link>
              . Choice chips are initially displayed in the deselected gray
              state. Once selected, the chip will change to its green selected
              state and cannot be deselected unless another chip is selected.
            </p>
          }
          code={code.chipActive}
        >
          <div class="c-chip__container">
            <span class="c-chip c-chip--active">Option 1</span>
            <span class="c-chip l-margin-left--xsmall">Option 2</span>
            <span class="c-chip l-margin-left--xsmall">Option 3</span>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  /*
  chipActive: `<div class="c-chip__container">
  <div class="c-chip c-chip--active">
  Lorem Ipsum
  </div>
</div>`,
  chipBase: `<div class="c-chip__container">
  <div class="c-chip">
    Lorem Ipsum
  </div>
</div>`,
  chipClose: `<div class="c-chip__container">
  <div class="c-chip c-chip--active">
    Lorem Ipsum <div class="c-chip__close" />
  </div>
</div>` */
}
